import React, { ReactElement } from 'react'
import i18n from 'live/services/i18n'
import Toggle from '../Toggle'
import NumericField from '../NumericField'

interface Props {
    tableModeConfig: {
        enable: boolean
        columns: number
        rows: number
        showUOM?: boolean
        useChannelColor?: boolean
    }
    changeConfig: (field: string, value: unknown, sideEffects?: Record<string, boolean>) => void
    isEditor: boolean
}

// TODO: add showUOM and useChannelColor to the config
export default function TableModeConfigView({ tableModeConfig, changeConfig, isEditor }: Props): ReactElement {
    const { enable = false, columns = 0, rows = 0 } = tableModeConfig || {}

    return (
        <div className="group-configs-container">
            <Toggle
                label={i18n('Table mode')}
                value={enable}
                configKey={'tableModeConfig'}
                onChange={() => {
                    changeConfig('tableModeConfig', {
                        ...tableModeConfig,
                        enable: !enable
                    })
                }}
            />

            <br />

            {enable && (
                <>
                    <NumericField
                        label={i18n('Number of rows')}
                        value={rows}
                        configKey={'tableModeConfig'}
                        onChange={(configKey, value) => {
                            changeConfig(configKey, {
                                ...tableModeConfig,
                                rows: value
                            })
                        }}
                        minValueAllowed={0}
                        className={isEditor ? 'dropdown-toggler--cancel-drag' : ''}
                    />

                    <NumericField
                        label={i18n('Number of columns')}
                        value={columns}
                        configKey={'tableModeConfig'}
                        onChange={(configKey, value) => {
                            changeConfig(configKey, {
                                ...tableModeConfig,
                                columns: value
                            })
                        }}
                        minValueAllowed={0}
                        className={isEditor ? 'dropdown-toggler--cancel-drag' : ''}
                    />
                    <br />
                </>
            )}
        </div>
    )
}
